import Supporters from "../../../../src/events/2022/05/supporters/index.js";
import * as React from 'react';
export default {
  Supporters,
  React
};